<template>
  <div class="page-my-order">
    <ym-tabs v-model="tabSelected">
      <ym-tab name="all" title="全部">
        <order-list :records="all.list"
                    :type="all.type"
                    :next-start="all.start"
                    :show-empty-page="all.showEmptyPage"
        />
      </ym-tab>

      <ym-tab name="unpaid" title="未支付">
        <order-list :records="unpaid.list"
                    :type="unpaid.type"
                    :next-start="unpaid.start"
                    :show-empty-page="unpaid.showEmptyPage"
        />
      </ym-tab>

      <ym-tab name="paid" title="已支付">
        <order-list :records="paid.list"
                    :type="paid.type"
                    :next-start="paid.start"
                    :show-empty-page="paid.showEmptyPage"
        />
      </ym-tab>
    </ym-tabs>
  </div>
</template>

<script>
  import { Tabs, Tab } from '@ymba/ym-ui';
  import OrderList from '@/pages/My/components/OrderList';
  import { getMyOrderList } from '@/services/order';
  import { LIMIT } from '@/utils/constant';

  export default {
    name: 'PageMyOrder',
    metaInfo: {
      title: '我的订单',
    },
    components: {
      'ym-tabs': Tabs,
      'ym-tab': Tab,
      OrderList,
    },
    data() {
      return {
        tabSelected: 'all',
        all: {
          type: 'all',
          start: 0,
          list: [],
          showEmptyPage: false,
        },
        unpaid: {
          type: 'unpaid',
          start: 0,
          list: [],
          showEmptyPage: false,
        },
        paid: {
          type: 'paid',
          start: 0,
          list: [],
          showEmptyPage: false,
        },
      };
    },
    methods: {
      getOrderListData(start, type, silentRequest) {
        return getMyOrderList({
          limit: LIMIT,
          start,
          type,
        }, silentRequest);
      },
      getAllOrderData() {
        return new Promise(async (resolve, reject) => {
          try {
            const data = await this.getOrderListData(
              this.all.start,
              this.all.type,
              false,
            );
            this.all.list = data.list;
            this.all.start = data.start;
            if (data.list.length === 0 && this.all.list.length === 0) {
              this.all.showEmptyPage = true;
            }
            return resolve();
          } catch (e) {
            return reject(e);
          }
        });
      },
      getUnpaidOrderData() {
        return new Promise(async (resolve, reject) => {
          try {
            const data = await this.getOrderListData(
              this.unpaid.start,
              this.unpaid.type,
              true,
            );
            this.unpaid.list = data.list;
            this.unpaid.start = data.start;
            if (data.list.length === 0 && this.unpaid.list.length === 0) {
              this.unpaid.showEmptyPage = true;
            }
            return resolve();
          } catch (e) {
            return reject();
          }
        });
      },
      getPaidOrderData() {
        return new Promise(async (resolve, reject) => {
          try {
            const data = await this.getOrderListData(
              this.paid.start,
              this.paid.type,
              true,
            );
            this.paid.list = data.list;
            this.paid.start = data.start;
            if (data.list.length === 0 && this.paid.list.length === 0) {
              this.paid.showEmptyPage = true;
            }
            return resolve();
          } catch (e) {
            return reject();
          }
        });
      },
    },
    async created() {
      const { query } = this.$route;
      const { type } = query;
      if (type && type !== '') {
        this.tabSelected = type;
      }

      this.getAllOrderData();
      this.getUnpaidOrderData();
      this.getPaidOrderData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-my-order {
    height: 100%;
    background-color: @color-white;
  }
</style>
